import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-manager',
  standalone: false,
  templateUrl: './store-manager.component.html',
  styleUrl: './store-manager.component.css'
})
export class StoreManagerComponent {
  shareObject: any = {
    selectedRows: new Set(),
    lastSelectedIndex: null,
    component: '/store_manager',
    addURL: '/user/store/create',
    editURL: '/user/store/edit',
    bulkURL: '/user/store/create/bulk',
    deletedURL: '/user/store/deleted',
    listURL: '/user/store/manager',
    keyFile: ['Tên', 'Địa chỉ', 'Nhãn', 'Vị trí'],

  };
  formHandle!: FormGroup;
  filterForm!: FormGroup;
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = {
      filter: {},
      page: 1,
      limit: this.sharedService.env.pageSize[0]
    };
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.itemId = params['id'];
      }
    })
  }
  ngOnInit(): void {
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.formHandle = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      address: [''],
      labels: [''],
    })
    this.filterForm = this.fb.group({
      limit: [this.sharedService.env.pageSize[0]],
      startDate: [''],
      endDate: [''],
      keyword: [''],
    })
    // this.listUser();
    if (this.shareObject.data.type == 'edit') {
      this.getItem();
    } else {
      this.getItems();
    }
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    let path = this.shareObject.data.type == 'deleted' ? `${this.shareObject.component}/list_deleted` : `${this.shareObject.component}/list`;
    this.sharedService.callApi(path, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false;
        this.shareObject.items = res.data.data.map((item: any) => {
          item.checked = false;
          item.editURL = `${this.shareObject.editURL}/${item.id}`
          return item;
        });
        this.shareObject.pagination = res.data.pagination;
        this.cdRef.detectChanges();
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.filterForm.reset();
    this.filterForm.patchValue({
      limit: this.sharedService.env.pageSize[0],
      startDate: '',
      endDate: '',
    })
    this.shareObject.selectedRows.clear();
    this.getItems();
  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/get`, { id: this.shareObject.itemId }).subscribe({
      next: (res: any) => {
        this.formHandle.patchValue({
          name: res.data.name,
          address: res.data.address,
          labels: res.data.labels.join(', '),
        })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  addItem() {
    const payload = {
      name: this.formHandle.value.name,
      address: this.formHandle.value.address,
      labels: this.formHandle.value.labels.split(',').map((label: string) => label.trim()).filter((label: string) => label.length > 0),
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/add`, payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('add_success'),
            type: 'success',
          });
          this.router.navigate([this.shareObject.listURL]);
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  updateItem() {
    const payload = {
      id: this.shareObject.itemId,
      name: this.formHandle.value.name,
      address: this.formHandle.value.address,
      labels: this.formHandle.value.labels.split(',').map((label: string) => label.trim()).filter((label: string) => label.length > 0),
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/update`, payload).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
        this.sharedService.back();
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  onSubmit() {
    console.log(this.formHandle.invalid);
    //show invalid field
    console.log(this.formHandle.value);

    this.sharedService.validateForm(this.formHandle);
    if (this.shareObject.data.type == 'edit') {
      this.updateItem()
    }
    else {
      this.addItem()
    }
  }
  deleteItem(ids: string[]) {
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getItems();
  }
  changeStatus(id: string, status: number) {
    this.sharedService.callApi(`${this.shareObject.component}/update`, { id, status }).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
        this.router.navigate([this.shareObject.listURL]);
      }
      , error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  softDeleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_soft_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  restoreItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_restore'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/restore_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('restore_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  filter(key: string, value: any): void {
    console.log(key, value);
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      delete this.shareObject.options.filter[key];
    } else {
      this.shareObject.options.filter[key] = key == 'lables' ? { $in: [value] } : value;
      this.filterForm.patchValue({ [key]: value });
    }
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  onSearch() {
    if (this.filterForm.value.startDate && this.filterForm.value.startDate != '') {
      this.shareObject.options.filter.createdAt = { $gte: new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0) };
    }
    if (this.filterForm.value.endDate && this.filterForm.value.endDate != '') {
      this.shareObject.options.filter.createdAt = { ...this.shareObject.options.filter.callAt, $lte: new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999) };
    }
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ?? undefined;
    this.shareObject.options.limit = this.filterForm.value['limit'] ?? this.sharedService.env.pageSize[0];
    // this.shareObject.options.filter.tags = { $in: this.filterForm.value['tags'] }
    this.shareObject.options.page = 1;
    this.getItems();
  }
  isAllSelected(data: any[] = []): boolean {
    return this.shareObject.selectedRows.size === data.length;
  }
  toggleSelectAll(event: Event, data: any[]) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      data.forEach((_, index) => this.shareObject.selectedRows.add(index));
    } else {
      this.shareObject.selectedRows.clear();
    }
  }
  selectRow(event: MouseEvent, index: number) {
    //check nếu index đã có trong selectedRows thì bỏ chọn
    if (this.shareObject.selectedRows.has(index)) {
      this.toggleRowSelection(index);
      return;
    }
    if (event.ctrlKey || event.metaKey) {
      // Ctrl/Cmd click: toggle selection
      this.toggleRowSelection(index);
    } else if (event.shiftKey && this.shareObject.lastSelectedIndex !== null) {
      // Shift click: select range
      this.selectRange(this.shareObject.lastSelectedIndex, index);
    } else {
      // Regular click: single selection
      this.selectSingleRow(index);
    }
    this.shareObject.lastSelectedIndex = index;
  }
  toggleRowSelection(index: number) {
    if (this.shareObject.selectedRows.has(index)) {
      this.shareObject.selectedRows.delete(index);
    } else {
      this.shareObject.selectedRows.add(index);
    }
  }
  selectSingleRow(index: number) {
    this.shareObject.selectedRows.clear();
    this.shareObject.selectedRows.add(index);
  }
  selectRange(start: number, end: number) {
    this.shareObject.selectedRows.clear();
    const [from, to] = [Math.min(start, end), Math.max(start, end)];
    for (let i = from; i <= to; i++) {
      this.shareObject.selectedRows.add(i);
    }
    console.log(this.shareObject.selectedRows)
  }
  handleIndextoId(idexes: any) {
    const selectedIds = Array.from(idexes).map((index: any) => this.shareObject.items[index].id);
    return selectedIds;
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }
  uploadBulk(data: any) {
    data = data.map((e: any) => {
      e.name = e['Tên'];
      e.address = e['Địa chỉ'];
      e.labels = e['Nhãn'];
      e.info = {};
      e.info.latitude = e['Vị trí'].split(',')[0].trim();
      e.info.longitude = e['Vị trí'].split(',')[1].trim();
      delete e['Vị trí'];
      return e;
    });
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/add_many`, { data }).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('upload_success'),
          type: 'success',
        });
        // this.router.navigate(['/user/phone/contact']);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  downloadSample() {
    const data: any[] = [
      { 'Tên': 'AQB1', 'Địa chỉ': 'Số 1 Nguyễn Phước Tần', 'Nhãn': 'KHTT,DN', 'Vị trí': '16.05347965245022, 108.15602521032281' },
      { 'Tên': 'AQB2', 'Địa chỉ': 'Số 2 Nguyễn Phước Tần', 'Nhãn': 'CTY', 'Vị trí': '16.05347965245022, 108.15602521032281' },
      { 'Tên': 'AQB3', 'Địa chỉ': 'Số 3 Nguyễn Phước Tần', 'Nhãn': 'KHTT,DN', 'Vị trí': '16.05347965245022, 108.15602521032281' },
    ];

    // Hàm xử lý escape & bọc dấu ngoặc kép
    const escapeValue: any = (val: string) => {
      if (val == null) return '';
      const stringVal = String(val).replace(/"/g, '""'); // escape dấu ngoặc kép
      return `"${stringVal}"`;
    };
    const title = ['Tên', 'Địa chỉ', 'Nhãn', 'Vị trí'];
    const header = title.map(escapeValue).join(',');
    const rows = data.map((row) =>
      title.map((col: any) => escapeValue(row[col])).join(',')
    );
    const csvContent = [header, ...rows].join('\r\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sample.csv';
    a.click();
    URL.revokeObjectURL(url); // cleanup
  }

}